var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappybatiFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 333,
    height: 65,
    viewBox: "0 0 333 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "HappyBati.fr",
    transform: "translate(333 52)",
    fill: "#fa8e20",
    fontSize: 50,
    fontFamily: "Futura-Bold, Futura",
    fontWeight: 700,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -332.95,
    y: 0,
    fill: "#000"
  }, "HappyBati"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#fa8e20"
  }, ".fr"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappybatiFooter);
export default __webpack_public_path__ + "static/media/happybati-footer.877247f70d8d5f019c7994d0f38488e3.svg";
export { ForwardRef as ReactComponent };